"use client";

import { useEffect, useState } from "react";

export default function CookieBanner() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (typeof document === "undefined") return;
    const consent = document.cookie.match(/(?:^|; )cookieConsent=([^;]+)/);
    if (!consent) setShow(true);
  }, []);

  function accept(value: "all" | "essential") {
    const oneYear = 60 * 60 * 24 * 365;
    document.cookie = `cookieConsent=${value}; path=/; max-age=${oneYear}; SameSite=Lax`;
    setShow(false);
  }

  if (!show) return null;
  return (
    <div className="cookie-banner fixed bottom-0 inset-x-0 z-40 bg-white border-t border-neutral-200 px-4 py-3 shadow-lg">
      <div className="max-w-5xl mx-auto flex flex-col sm:flex-row items-start sm:items-center gap-3 text-sm">
        <p className="flex-1 text-neutral-700">
          We use essential cookies to keep you signed in. We don&apos;t use third-party tracking.
          Read our <a href="/privacy" className="text-rose-600 hover:underline">privacy policy</a>.
        </p>
        <div className="flex gap-2 shrink-0">
          <button
            onClick={() => accept("essential")}
            className="text-xs px-3 py-1.5 border border-neutral-300 rounded-lg hover:bg-neutral-50"
          >
            Essential only
          </button>
          <button
            onClick={() => accept("all")}
            className="text-xs px-3 py-1.5 bg-rose-600 hover:bg-rose-700 text-white rounded-lg font-medium"
          >
            Got it
          </button>
        </div>
      </div>
    </div>
  );
}
